import * as React from "react";
const SvgButtonTable = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	dimensions: "0 0 24 24",
	height: 24,
	width: 24,
	...props
}, /* @__PURE__ */ React.createElement("g", {
	stroke: "#000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}, /* @__PURE__ */ React.createElement("path", { d: "M8.25 3.748h15M8.25 12.748h15M8.25 21.748h15M.8 18.36a1.5 1.5 0 111.45 1.888 1.501 1.501 0 01.002 3 1.5 1.5 0 01-1.446-1.1M.75 11.248a1.5 1.5 0 011.5-1.5h0a1.5 1.5 0 011.5 1.5h0c0 .486-.165.957-.468 1.336L.75 14.248h3M.75.748h.75a.75.75 0 01.75.75v5.25M.75 6.748h3" })));
export { SvgButtonTable as ReactComponent };
